export const tradeConsultantAPIUrl = `${process.env.REACT_APP_API_URL}api/member-trade-consultants`;
export const workingFinYearAPIUrl = `${process.env.REACT_APP_API_URL}api/get-working-finyear`;
